import { Injectable } from '@angular/core';
import { DominioCombo } from '@core/models/dominio';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

const baseRef = 'validaCpfCnpj';
const route = {
    validaCpfCnpj: `${baseRef}`
}

@Injectable({
  providedIn: 'root'
})
export class ValidaCpfCnpjService {

  constructor(
    private apiService: ApiService,
  ) { }

  validaCpfCnpj(cpfCnpj: any): Observable<Boolean>  {
    const params = new HttpParams().set('cpfCnpj', cpfCnpj);

    // Passando o objeto de opções corretamente com os parâmetros
    return this.apiService.get<boolean>(route.validaCpfCnpj, params);
  }
}
